import React from 'react'
import styled from 'styled-components'
import { sizes, colors } from '../../css-variables'

function Byline({ className, children }) {
  return <ul className={className}>{children}</ul>
}

const StyledByline = styled(Byline)`
  padding-right: ${sizes.s10};
  margin-left: 0;
  margin-bottom: 0;
  list-style: none;

  .byline-item {
    display: inline-block;
    font-size: ${sizes.s16};
    border-right: 2px solid ${colors.copyText};
    padding: 0 ${sizes.s10} 0 ${sizes.s10};
    margin-bottom: 0;
    font-weight: 500;
    :first-child {
      padding-left: 0;
    }
    :last-child {
      border-right: none;
    }
  }
`

export default StyledByline
